import React, { useEffect, useState } from "react";
import ReactLoading from "react-loading";
import Filter from "./Filter";
import CardSlider from "./CardSlider";
import styles from "./Components.module.css";
import apis from "../services";
import NewPools from "./NewPools";

function Invest() {
  const [cards, setCards] = useState([]);
  const [tokens, setTokens] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingFilters, setLoadingFilters] = useState(false);
  const [error, setError] = useState(null);
  const [filters, setFilters] = useState({
    chainName: "all",
    age: "all",
    score: "all",
    liquidity: "all",
    volume: "all",
  });
  const [page, setPage] = useState(1);
  const pageSize = 20;

  const fetchCards = async (showLoader = true, currentPage = page) => {
    if (showLoader) setLoading(true);
    setError(null);
    try {
      const [response2, response] = await Promise.all([
        apis.fetchtop({ ...filters, page: currentPage, page_size: pageSize }),
        apis.checktoken({ ...filters, page: currentPage, page_size: pageSize }),
      ]);

      if (response && response.tokenDetails) {
        if (currentPage === 1) {
          setCards(response2.tokenDetails || []);
          setTokens(response.tokenDetails || []);
        } else {
          setCards((prev) => [...prev, ...(response2.tokenDetails || [])]);
          setTokens((prev) => [...prev, ...(response.tokenDetails || [])]);
        }
      } else {
        if (currentPage === 1) setCards([]);
      }
    } catch (err) {
      setError(err.message || "Failed to fetch data");
      console.error("Error fetching cards:", err.message);
    } finally {
      if (showLoader) setLoading(false);
    }
  };

  useEffect(() => {
    fetchCards(true, 1);
  }, []);

  const handleShowMore = async () => {
    try {
      setLoading(true);
      const nextPage = page + 1;
      setPage(nextPage);
      await fetchCards(false, nextPage);
    } catch (err) {
      setError(err.message || "Failed to fetch additional data");
      console.error("Error fetching additional data:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ overflowX: "hidden" }}>
      <div className="invest-background">
        {cards.length > 0 || tokens.length > 0 ? (
          <>
            <div className={styles.investTop}>
              {cards.length > 0 && (
                <Filter
                  setFilters={setFilters}
                  fetchCards={fetchCards}
                  loading={loading}
                />
              )}
              {error && <p style={{ color: "red" }}>{error}</p>}
              {cards.length > 0 && (
                <CardSlider
                  cards={cards}
                  tokens={tokens}
                  heading="Decentralized Exchange"
                />
              )}
            </div>
            <NewPools
              tokens={tokens}
              showHeader={false}
              onShowMore={handleShowMore}
              loading={loading}
            />
          </>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh",
              width: "100vw",
              position: "fixed",
              top: 0,
              left: 0,
              zIndex: 9999,
            }}
          >
            <div className="dot-spinner">
              <div className="dot-spinner__dot"></div>
              <div className="dot-spinner__dot"></div>
              <div className="dot-spinner__dot"></div>
              <div className="dot-spinner__dot"></div>
              <div className="dot-spinner__dot"></div>
              <div className="dot-spinner__dot"></div>
              <div className="dot-spinner__dot"></div>
              <div className="dot-spinner__dot"></div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Invest;
